import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03774c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "company-name" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "search-container" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

import {onMounted, onUnmounted, ref} from "vue";
import DataTable from "primevue/datatable";
import swal from "@/_helpers/swal";
import {fetchUserMatriculesByCompany, toggleCompanyMatriculeAvailable} from "@/_services/companyMatricule/companyMatricule";
import {IUserMatriculeByCompany} from "@/models/companyMatricule/IUserMatriculeByCompany";
import {useCompanyMatriculeStore} from "@/stores/companyMatricule/companyMatriculeStore";
import {useToast} from 'primevue/usetoast';
import {onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter} from "vue-router";
import {useConfirm} from 'primevue/useconfirm';
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Column from "primevue/column";
import Button from "primevue/button";
import ConfirmDialog from "primevue/confirmdialog";

const defaultRowsPerPage = 10;
type Sort = {
    fieldLabel: string;
    fieldValue: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMatriculesByCompany',
  setup(__props) {

const toast = useToast();
const confirm = useConfirm();
const route = useRoute();
const router = useRouter();
const store = useCompanyMatriculeStore();
const isLoading = ref<boolean>(true);
const tableData = ref<IUserMatriculeByCompany[]>([]);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(1);
const globalSearch = ref<string>("");
const modeSortable = ref<boolean>(false);
const isAvailable = ref<boolean | undefined>(undefined);
const companyName = ref<string>("");
const defaultsSort: Sort = {
    fieldLabel: "order[id]",
    fieldValue: "DESC",
};

const currentSort = ref<Sort | undefined>(undefined);

const companyUuidRouteParam = ref<string>('');

onMounted(async () => {
    companyUuidRouteParam.value = route.params.uuid as string;
    if (companyUuidRouteParam.value) {
        await populateDatatable(companyUuidRouteParam.value, rows.value, page.value, globalSearch.value, defaultsSort);
    } else {
        swal.error("Aucun identifiant de société trouvé dans l'URL.");
    }
    
    if (store.getSelectedCompany) {
        companyName.value = store.getSelectedCompany.name
    }
});

const populateDatatable = async (
    companyUuid: string,
    itemsPerPage: number,
    page: number,
    globalSearch?:string,
    sort?: Sort,
    available?: boolean
) => {
    showSpinner();
    
    const [isLoadingDt, totalRecordsDt, tableDataDt] = await fetchUserMatriculesByCompany(companyUuid, itemsPerPage, page, globalSearch, sort, available);
    isLoading.value = isLoadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    hideSpinner();
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page + 1;
    showSpinner();
    await populateDatatable(companyUuidRouteParam.value, e.rows, currentPage.value, globalSearch.value, currentSort.value, isAvailable.value);
};

const onGlobalFilterKeyEnter = () => {
    if (globalSearch.value.trim() != "") {
        showSpinner();
        populateDatatable(companyUuidRouteParam.value, rows.value, page.value, globalSearch.value);
    }
};

const onGlobalFilterInput = () => {
    if (globalSearch.value === "") {
        showSpinner();
        populateDatatable(companyUuidRouteParam.value, rows.value, page.value);
    }
};

const onSort = (e) => {
    showSpinner();
    if (e.sortField) {
        if (e.sortField !== "available") {
            currentSort.value = {
                fieldLabel: "order[" + e.sortField + "]",
                fieldValue: e.sortOrder === 1 ? "asc" : "desc",
            };

            isAvailable.value = undefined;
        } else {
            currentSort.value = undefined;
            isAvailable.value = e.sortOrder === 1;
        }
        
        modeSortable.value = true;
        populateDatatable(companyUuidRouteParam.value, rows.value, page.value, globalSearch.value, currentSort.value, isAvailable.value);
    } else {
        isAvailable.value = undefined;
        currentSort.value = undefined;
        modeSortable.value = false;
        populateDatatable(companyUuidRouteParam.value, rows.value, page.value, globalSearch.value, defaultsSort);
    }
};

const editCompanyMatricule = (companyMatricule: IUserMatriculeByCompany) => {
    store.setSelectedMatricule(companyMatricule);
    router.push({
        name: 'editCompanyMatricule',
        params: { uuid: companyMatricule.uuid }
    });
};

const confirmChangeAvailableDialog = async (newValue: boolean, data: IUserMatriculeByCompany) => {
    const currentStatus = data.available;
    let newStatus = currentStatus ? 'désactiver' : 'activer';
    
    confirm.require({
        group: 'global',
        message: `Êtes-vous sûr de vouloir ${newStatus} ce matricule pour cette société ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'my-custom-accept-class',
        accept: async () => {
            try {
                showSpinner();
                await toggleCompanyMatriculeAvailable(data).then((response) => {
                    if (!response) {
                        throw Error
                    }
                });
                toast.add({ severity: 'success', summary: 'Success', detail: 'Le matricule a bien été modifié !', life: 3000 });
                await populateDatatable(companyUuidRouteParam.value, rows.value, currentPage.value, globalSearch.value, currentSort.value, isAvailable.value);
            }  catch (error) {
                toast.add({ severity: 'error', summary: 'Error', detail: 'Une erreur est survenue.', life: 3000 });
                hideSpinner();
            }
        },
    });
};

onUnmounted(() => {
    store.clearSelectedCompany();
});

onBeforeRouteLeave(() => {
    store.clearSelectedCompany();
});

onBeforeRouteUpdate(() => {
    store.clearSelectedCompany();
});

const showSpinner = () => {
    isLoading.value = true;
};

const hideSpinner = () => {
    isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        style: {"margin-bottom":"15px"},
        class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'companyMatriculeWithUserList' })))
      }, [
        _hoisted_1,
        _createTextVNode(" Retour ")
      ]),
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode("Liste des matricules utilisateur du client "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(companyName.value), 1)
      ]),
      _createVNode(_component_Toast),
      _createVNode(_unref(ConfirmDialog), {
        group: "global",
        closeOnEscape: false,
        closable: false
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        removableSort: "",
        paginator: "",
        filterDisplay: "row",
        tableStyle: "min-width: 50rem",
        showGridlines: "",
        stripedRows: "",
        columnResizeMode: "fit",
        value: tableData.value,
        rowHover: true,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        onPage: onPaginate,
        onSort: _cache[4] || (_cache[4] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: globalSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((globalSearch).value = $event)),
                placeholder: "Rechercher un client, matricule",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onGlobalFilterKeyEnter()), ["enter"])),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (onGlobalFilterInput()))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "userMatricule",
            header: "Matricule",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.userMatricule), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "user.email",
            header: "Email",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.user ? slotProps.data.user.email : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "user.firstname",
            header: "Client",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.user
                          ? `${slotProps.data.user.firstname} ${slotProps.data.user.lastname}`
                          : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "available",
            header: "Activer / Désactiver",
            showFilterMenu: false,
            sortable: "",
            style: { textAlign: 'center' }
          }, {
            body: _withCtx((slotProps) => [
              (!slotProps.data.user || !slotProps.data.user.email)
                ? (_openBlock(), _createBlock(_unref(InputSwitch), {
                    key: 0,
                    "model-value": slotProps.data.available,
                    "onUpdate:modelValue": (value) => confirmChangeAvailableDialog(value, slotProps.data)
                  }, null, 8, ["model-value", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Editer",
            showFilterMenu: false
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Button), {
                type: "button",
                onClick: ($event: any) => (editCompanyMatricule(slotProps.data)),
                icon: "pi pi-pencil",
                title: "Modifier",
                severity: "info",
                class: "ml-2"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})